<template>
	<div>

		<div class="flex">
			<div class="flex-basis">
				<CustomerSearch v-model="customer" />
			</div>
			<div class="flex-basis">
				<div v-if="customer" class="flex">
					<div>
						<div><strong>Send to</strong></div>
						<div>{{ customer.full_name }}</div>
						<div class="note">{{ customer.email }}</div>
					</div>
					<div class="margin-left">
						<button class="small gray" v-on:click="customer = false;">Clear</button>
					</div>
				</div>
			</div>
		</div>

		<div v-if="customer" class="flex margin-top">
			<div class="flex-basis">
				<div>
					<strong>Template</strong>
				</div>
				<select v-model="identifier">
					<option value="subscription:renewed">Subscription renewed</option>
				</select>
			</div>
			<div class="flex-basis">
				<button
					:disabled="saving || !identifier || !customer"
					v-on:click="send">Send now</button>
			</div>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    customer: false,
    saving: false,
    identifier: false
  }),
  methods: {
    send () {
      Vue.$api.post('/customer/' + this.customer.id + '/email', {
        identifier: this.identifier
      }, {
        loader: toggle => this.saving = toggle,
        callback: () => alert('Email has been queued :-)')
      })
    }
  }
}
</script>
